import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import globalMethods from './utility/globalMethods'
import { quillEditor } from 'vue3-quill'

// Vuetify
import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'

const vuetify = createVuetify({
  components,
  directives,
});

import './assets/css/reset.css';
import './assets/css/admin/admin.css';
import './assets/css/user/user.css';

const app = createApp(App);

app
  .use(store)
  .use(router)
  .use(globalMethods)
  .use(quillEditor)
  .use(vuetify)
  .mount('#app');
